import { createIcon } from "@chakra-ui/react";

export const TriangleDown = createIcon({
  displayName: "TriangleDown",
  viewBox: "0 0 72 72",
  path: [
    <mask
      id="6yi9yoo17a"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="73"
      height="72"
    >
      <path fill="#D9D9D9" d="M.864 0h72v72h-72z" />
    </mask>,
    <g mask="url(#6yi9yoo17a)">
      <path
        d="m65.768 17.875-1.198 3.822-1.053 3.892-1.29 3.809-1.85 3.615-1.089 3.879-1.708 3.664-.918 3.939-1.898 3.598-.986 3.915-1.304 3.804-1.252 3.823-1.203 4.023-3.742-1.96-4.019-.642-3.793-1.29-3.799-1.274-3.718-1.505-3.78-1.33-3.604-1.834-3.96-.809-3.816-1.227-3.623-1.778-3.734-1.464L5 47.667l2.92-2.072 3.826-1.298 3.56-1.85 3.574-1.82 3.67-1.62 3.365-2.254 3.618-1.73 4.024-.887 3.268-2.457 3.715-1.528 3.754-1.448 3.673-1.615 3.507-1.96 3.708-1.544 3.265-2.463 3.713-1.535 3.608-1.71z"
        fill="currentColor"
      />
    </g>,
  ],
  defaultProps: {
    color: "#F0A32F",
  },
});

export default TriangleDown;
